import { EditableCoverImage } from './types';

export function isFile(coverImage?: EditableCoverImage): coverImage is File {
  return coverImage instanceof File;
}

export function getPreview(value?: EditableCoverImage) {
  if (isFile(value)) {
    return URL.createObjectURL(value);
  }

  return value?.image?.mediaId as string | undefined;
}
